// Lo que responde el backend cuando el token de sesión ya no sirve: los tres
// primeros vienen tal cual de `jsonwebtoken`, el último de `auth/access.ts`.
const INVALID_SESSION_MESSAGES = ['invalid signature', 'jwt expired', 'jwt malformed', 'invalid token'];

let invalidSessionHandler: (() => void) | null = null;

/** Registra qué hacer cuando el backend rechaza el token de sesión. */
export const onInvalidSession = (handler: () => void) => { invalidSessionHandler = handler; };

/**
 * Avisa si el error de una llamada al backend es el rechazo del token de sesión.
 * Solo cuenta si el token rechazado es el de la sesión: otros endpoints reciben
 * tokens propios (invitación, restablecer contraseña) que fallan con el mismo texto.
 */
export const reportIfInvalidSession = (message: unknown, args: any[]) => {
    if (typeof message !== 'string' || !INVALID_SESSION_MESSAGES.includes(message.toLowerCase())) return;
    const token = localStorage.getItem('token');
    if (token && args.includes(token)) invalidSessionHandler?.();
};
